<template>
    <div class="uni-input-radio">
        <slot />
        <label :for="id">
            <div>
                <div class="radio">
                    <div class="button"></div>
                    <div class="hover-effect"></div>
                </div>
                <span class="uni-body">
          {{ label }}
        </span>
            </div>
        </label>
    </div>
</template>

<script>
    export default {
        name: "BeautifullInputRadio",
        props:{
            label:{
                type:String,
                default: 'Input Radio',
            },
            id:{
                type:String
            }
        }
    }
</script>

<style scoped lang="scss">
    .uni-input-radio{
        margin-bottom: 6px;
        label{
            cursor:pointer;
            margin:0;
            span{
                margin-bottom: 0;
            }
            >div{
                display:inline-flex;
                align-items: center;
            }
        }
        input {
            opacity:0;
            height: 0px;
            position:absolute;
        }
        input:focus+label{
            .radio{
                .hover-effect{
                    opacity:.6;
                }
            }
        }
        input:checked+label{
            .radio{
                >.button{
                    border: 2px solid var(--color-primary);
                    &:before{
                        transform:scale(1);
                    }
                }
            }
        }
        .radio{
            >.button{
                position:relative;
                z-index:2;
                height:20px;
                width: 20px;
                margin-right:8px;
                border:2px solid var(--color-grey-light-1);
                border-radius:18px;
                transition:var(--transition-quick);
                &:before{
                    content:"";
                    position:absolute;
                    height:10px;
                    width: 10px;
                    border-radius:8px;
                    background:var(--color-primary);
                    margin-top:3px;
                    margin-left:3px;
                    transition:var(--transition-quick);
                    transform:scale(0);
                }
            }
            &:hover{
                >.hover-effect{
                    opacity:.3;
                }
            }
            >.hover-effect{
                position:absolute;
                z-index:1;
                height: 40px;
                width: 40px;
                margin-top:-30px;
                margin-left:-10px;
                border-radius:100px;
                background:var(--color-grey-light-1);
                opacity:0;
                transition: var(--transition-quick);
            }
        }
    }
</style>
